import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { Constants } from "./../../../helper/constants";
import { IShift } from "./../../../helper/contracts";
import { Shift } from "./shift";
import * as firebase from "firebase";

@Injectable()
export class ShiftService {
  private shiftsPath: string;

  constructor(private db: AngularFireDatabase) {
    this.shiftsPath = Constants.SHIFT_FIREBASE_REF;
  }

  getShifts(communityId: string): Observable<Array<Shift>> {
    return this.db
      .list(`${this.shiftsPath}/${communityId}`)
      .valueChanges()
      .map(shifts =>
        shifts.map(data => {
          const shift = { ...new Shift(), ...data };

          return shift;
        })
      );
  }

  getCommunityAssignedShiftIds(communityId: string): Observable<Array<string>> {

    const assignedShifts = {};

    return new Observable(observer => {
      this.db.list(`/access_terminal_shifts/${communityId}`)
      .valueChanges()
      .subscribe(data => {
        for (const item of data) {
          const shiftKeys = Object.keys(item);
          for (const key of shiftKeys) {
            assignedShifts[key] = true;
          }
        }

        observer.next(Object.keys(assignedShifts));
       });
    });
  }

  getCommunityAssignedShifts(communityId: string): Observable<Array<Shift>> {

    return new Observable(observer => {
      this.db
        .list(`/shifts/${communityId}`)
        .valueChanges()
        .subscribe(communityShiftsSnap => {
          if (communityShiftsSnap.length) {
            const communityShifts = {};
            for (const each of communityShiftsSnap) {
              const shift = { ...new Shift(), ...each };
              communityShifts[shift.id] = shift;
            }
            let commUserAssignedShifts;
            this.db.list(`/access_terminal_shifts/${communityId}`).snapshotChanges()
              .subscribe(userShits => {
                if (userShits.length) {
                  for (const userShift of userShits) {
                    const payload = userShift.payload;
                    if (commUserAssignedShifts === undefined) {
                      commUserAssignedShifts = {};
                    }

                    if (commUserAssignedShifts[payload.key] === undefined) {
                      commUserAssignedShifts[payload.key] = [];
                    }

                    const payloadValue = payload.val();

                    for (const shiftId of Object.keys(payloadValue)) {
                      if (
                        commUserAssignedShifts &&
                        commUserAssignedShifts[payload.key]
                      ) {
                        commUserAssignedShifts[payload.key].push(
                          communityShifts[shiftId]
                        );
                      }
                    }

                    observer.next(commUserAssignedShifts);
                  }
                } else {
                  observer.next([]);
                }
            });
          } else {
            observer.next([]);
          }
        });
    });
  }

  async assignShifts(shifts, communityId: string, userId: string): Promise<boolean> {
    try {
      const shiftsPayload = {};
      const shiftUsersPayload = {};
      for (const shift of shifts) {
        shiftsPayload[shift.id] = true;
        shiftUsersPayload[`${shift.id}/${userId}`] = true;
      }
      await this.db
        .list(`/access_terminal_shifts/${communityId}`)
        .update(userId, shiftsPayload);
      await this.db
        .list(`/shift_access_terminals`)
        .update(communityId, shiftUsersPayload);

      return true;
    } catch (e) {
      console.log(e);

      return false;
    }
  }

  async unassignShift(
    shift,
    communityId: string,
    userId: string
  ): Promise<boolean> {
    try {
      await this.db
        .list(`access_terminal_shifts/${communityId}/${userId}/${shift.id}`)
        .remove();
      await this.db
        .list(`shift_access_terminals/${communityId}/${shift.id}/${userId}`)
        .remove();

      return true;
    } catch (err) {
      console.log(err);

      return false;
    }
  }

  convertTimeToAMPM(time): any {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      time = time.slice(1);
      time[5] = +time[0] < 12 ? "AM" : "PM";
      time[0] = +time[0] % 12 || 12;
    }

    return time.join("");
  }

  async create(shift: IShift, communityId: string): Promise<boolean> {
    try {
      const shiftRef = this.db.list(`${this.shiftsPath}/${communityId}`);

      if (shift) {
        shift["viewStartTime"] = this.convertTimeToAMPM(shift.startTime);
        shift["viewEndTime"] = this.convertTimeToAMPM(shift.endTime);
      }

      const timestamp = firebase.database.ServerValue.TIMESTAMP;

      if (!shift.id) {
        shift.createdAt = timestamp;
        shift.updatedAt = timestamp;
        await shiftRef
          .push(shift)
          .then(data => shiftRef.update(data.key, { id: data.key }));
      } else {
        shift.updatedAt = timestamp;
        shiftRef.update(shift.id, shift);
      }

      return true;
    } catch (e) {
      console.log(e);

      return true;
    }
  }

  async update(shift: IShift, communityId: string): Promise<boolean> {
    try {
      shift.updatedAt = firebase.database.ServerValue.TIMESTAMP;
      shift["viewStartTime"] = this.convertTimeToAMPM(shift.startTime);
      shift["viewEndTime"] = this.convertTimeToAMPM(shift.endTime);
      this.db.list(`${this.shiftsPath}/${communityId}`).update(shift.id, shift);

      return true;
    } catch (e) {
      console.log(e);

      return false;
    }
  }

  async checkIsAssigned(shift: IShift, communityId: string): Promise<boolean> {
    return await new Promise<boolean>(resolve => {
      this.db
        .list(`shift_access_terminals/${communityId}/${shift.id}`)
        .valueChanges()
        .subscribe(shifts => {
          resolve(shifts.length > 0);
        });
    });
  }

  async delete(communityId: string, shiftId: string): Promise<boolean> {
    try {
      await this.db.object(`${this.shiftsPath}/${communityId}/${shiftId}`).remove();

      return true;
    } catch (e) {
      console.log(e);

      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/shift/shift.service.ts